import { InfoCircleOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { BaseDrawer } from "../../BaseDrawer";
import { BeaconMapLegend, LegendItem } from "../../map/BeaconMapLegend";
import { MarkerData, PolyLineData } from "../../map/Map";
import "./Map.css";
import { MapDetails } from "./MapDetails";

interface MapDrawerProps {
  isLoading: boolean;
  markers: MarkerData[];
  polyLines?: PolyLineData[];
  mapDrawerVisible: boolean;
  mapLegend: LegendItem;
  alertMessage?: string;
  onCloseDrawer: (visible: boolean) => void;
}

export function MapDrawer({
  isLoading,
  markers,
  polyLines,
  mapDrawerVisible,
  mapLegend,
  alertMessage,
  onCloseDrawer,
}: MapDrawerProps) {
  const { t } = useTranslation();

  const [isMapInfoVisible, setIsMapInfoVisible] = useState(false);
  const [renderMap, setRenderMap] = useState(false);

  const toggleMapInfo = (visible: boolean) => {
    setIsMapInfoVisible(visible);
  };

  return (
    <BaseDrawer
      title={t("beacon:position-map")}
      drawerVisible={mapDrawerVisible}
      onCloseDrawer={() => onCloseDrawer(false)}
      dataTestId="beacon-map-drawer"
      afterOpenChange={(open) => setRenderMap(open)}
    >
      <div className="beacon-map-drawer-info-div">
        <Button
          aria-label="map-drawer-info-button"
          type="text"
          className="info-button"
          icon={<InfoCircleOutlined />}
          onMouseEnter={() => toggleMapInfo(true)}
          onMouseLeave={() => toggleMapInfo(false)}
        />
        {isMapInfoVisible && (
          <BeaconMapLegend
            legendItems={[mapLegend]}
            style={{ right: "60px" }}
          />
        )}
      </div>
      {renderMap && (
        <MapDetails
          isLoading={isLoading}
          markers={markers}
          polyLines={polyLines}
          alertMessage={alertMessage}
        />
      )}
    </BaseDrawer>
  );
}
